var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGantsChimiques(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "gants_chimiques",
    "data-name": "gants chimiques",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1781.22 570.32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:url(#D\xE9grad\xE9_sans_nom_33);}.cls-4{fill:#214d29;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(-154 -846.43)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1037,1261s19-16,193,28,667,103,667,103,86-255,0-479c-217-2-755-32-860-43s-387-29-437-22-117,29-191,48c-20,6-43,33-56,43s-124,95-124,95c-12,19.44-11,33.09,5,40-45,30-75,85-17,101-54,21-22,96,41,77,0,0,110-42,167-42s239,5.66,259,12c68.74,21.75,52,50,4,67-87,33-193,0-224,21s-89,73-3,88c36,4,113,29,258,14,37-3.82,81.78-3.75,116-25C930,1328,1037,1261,1037,1261Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_33",
    x1: 1060.09,
    y1: 846.43,
    x2: 1060.09,
    y2: 1416.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#73a37d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#71a17b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#6b9876"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#618a6c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#52765f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#3f5d4e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#314a41"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "gant chimiques") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1037,1261s19-16,193,28,667,103,667,103,86-255,0-479c-217-2-755-32-860-43s-387-29-437-22-117,29-191,48c-20,6-43,33-56,43s-124,95-124,95c-12,19.44-11,33.09,5,40-45,30-75,85-17,101-54,21-22,96,41,77,0,0,110-42,167-42s239,5.66,259,12c68.74,21.75,52,50,4,67-87,33-193,0-224,21s-89,73-3,88c36,4,113,29,258,14,37-3.82,81.78-3.75,116-25C930,1328,1037,1261,1037,1261Z",
    transform: "translate(-154 -846.43)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M370.26,1217.58S261,1256,219,1229s-12.87-48.32-12.87-48.32L154,1210l74,76Z",
    transform: "translate(-154 -846.43)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M250,1149s-54.71,26.82-62.36-21.59S180,1168,180,1168l35,7Z",
    transform: "translate(-154 -846.43)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M320,1113s113-52,231-57c39-9,49-33,49-33s-26,27-95,31S320,1113,320,1113Z",
    transform: "translate(-154 -846.43)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M581,943s32,6,54-14S581,943,581,943Z",
    transform: "translate(-154 -846.43)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M620,888s36-4,36-14S620,888,620,888Z",
    transform: "translate(-154 -846.43)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M234,1074l137-74s-126,64-137,55-19-32-19-32v57Z",
    transform: "translate(-154 -846.43)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M716.8,1236.61S710,1194,415,1202c-68,6-111,59-111,59Z",
    transform: "translate(-154 -846.43)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M370,1000c75-38,81-45,211-57C496.52,937.25,458,946,370,1000Z",
    transform: "translate(-154 -846.43)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M620,888s-160,9-199,20-90.25,48.06-90.25,48.06S397,906,436,902C459,895,620,888,620,888Z",
    transform: "translate(-154 -846.43)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M908.86,1341S997,1249,1032,1249s134.67,25.06,134.67,25.06Z",
    transform: "translate(-154 -846.43)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGantsChimiques);
export default __webpack_public_path__ + "static/media/gants_chimiques.4970a479fc70bd62c9c8aeaf78a55b4e.svg";
export { ForwardRef as ReactComponent };